import React, { useState, useEffect, useRef } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, logout } from "../store/slices/usersSlice";
import { IoClose, IoMenu } from "react-icons/io5";
import { jwtDecode } from "jwt-decode";
import { resetAcgtCard, resetQuoteRequestPage, resetQuoteRequestState, setCardPage } from "../store";
import Confirm from "./Confirm";
import { url, urlClient } from "../configlink";

const Header = () => {
  const [isOrdersOpen, setIsOrdersOpen] = useState(false);
  const [isACGTCardOpen, setIsACGTCardOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  // const token = localStorage.getItem("token");

  const userState = useSelector((state) => state.user.user);
  let [nucoreUser, setNucoreUser] = useState(false)

  useEffect(() => {
    if(parseInt(userState.CoreLabId) === 1){
      setNucoreUser(true)
    }
    else{
      setNucoreUser(false)
    }
  }, [userState])

  // const isTokenValid = (token) => {
  //   if (!token) return true;
  //   try {
  //     const decoded = jwtDecode(token);
  //     const currentTime = Date.now() / 1000;
  //     return decoded.exp < currentTime;
  //   } catch (error) {
  //     console.error("Token decoding error:", error);
  //     return true; // If there's an error decoding, treat it as expired
  //   }
  // };

  useEffect(() => {
    const checkTokenExpiration = async () => {
      const isValid = await validateToken();
      if (!isValid) {
        // Redirect to login or logout
        dispatch(logout())
      }
    };

    checkTokenExpiration();

  }, []);


  const validateToken = async () => {

    try {
      const response = await fetch(`${url}/api/auth/validate`, {
        method: "GET",
        credentials: "include", // Include cookies
      });
  
      if (response.status === 200) {
        return true;
      } else if (response.status === 401 || response.status === 403) {
        // console.log("Token invalid or missing");
        return false;
      } else {
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Error checking authentication:", error);
      return false;
    }
  };

  const isTokenValid = async () => {
    const isValid = await validateToken();
    // console.log("ISVALID", isValid);
    if (!isValid) {
      // Handle expired token (e.g., log out the user)
      // console.log("Redirecting to login...");
      return false
    }
    else{
      return true
    }
  }

  const [showConfirm, setShowConfirm] = useState(false)
  let [message, setMessage] = useState('')

  const handleUserLogout = () => {
    setShowConfirm(true)
    setMessage('Are you sure you want to log out?')
   
  };

  const doAction = () => {
    setShowConfirm(false)
    dispatch(logout());

    try {
      fetch(`${url}/api/auth/logout`, {
        method: "POST",
        credentials: "include", // Send cookies along with the request
      })
      .then(res => res.json())
      .then(data => {
        if(data.message==='Logout successful'){
			localStorage.removeItem('user_token_expiry')
          navigate("/");
        }
      })
    } catch (error) {
      console.error(error);
      
    }
  }

  const toggleOrdersDropdown = () => {
    setIsOrdersOpen(!isOrdersOpen);
  };

  const toggleACGTCardDropdown = () => {
    setIsACGTCardOpen(!isACGTCardOpen);
  };

  const closeDropdowns = () => {
    setIsOrdersOpen(false);
    setIsACGTCardOpen(false);
    closeMenu();
  };

  const ordersDropdownRef = useRef(null);
  const acgtCardDropdownRef = useRef(null);

  useEffect(() => {
    // Add event listener to close dropdown when clicking outside
    function handleClickOutside(event) {
      if (
        ordersDropdownRef.current &&
        !ordersDropdownRef.current.contains(event.target) &&
        acgtCardDropdownRef.current &&
        !acgtCardDropdownRef.current.contains(event.target)
      ) {
        setIsOrdersOpen(false);
        setIsACGTCardOpen(false);
      }
    }

    // Attach the event listener
    document.addEventListener("click", handleClickOutside);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  let [menuToggle, setMenuToggle] = useState(false);

  const closeMenu = () => {
    setMenuToggle(false);
  };
  

    let [excludeCorp, setExcludeCorp] = useState(false)
	let wpsCorp = useSelector((state) => state.user.wpsExcludeCorp)  
	
    useEffect(() => {
		wpsValidity()
    }, [wpsCorp])
  
	function wpsValidity(){ 
		if(wpsCorp === true){
			setExcludeCorp(true)
		}
		else {
			setExcludeCorp(false)
		}
	}

  return (
    <>
    {showConfirm && 
        <Confirm isOpen={showConfirm} onClose={() => setShowConfirm(false)} message={message} doAction={doAction} />
        }
      <header className=' flex justify-between my-2 sm:!my-6 px-[25px] sm:px-[40px] xl:px-[72px]'>
        <div className='w-[60%] lg:w-full flex items-center'>
          {isLoggedIn === true ? (
            // <NavLink to='/dashboard'
            <NavLink to='https://acgtinc.com/'
            target="_blank"
            onClick={closeMenu}
            >
              <img
                className='min-w-[200px] w-[400px] h-auto my-4'
                src='/images/acgt-logo-2022.png'
                alt='acgt-logo'
              />
            </NavLink>
          ) : (
            <NavLink to='https://acgtinc.com/' 
            target="_blank"
            onClick={closeMenu}
            >
              <img
                className='min-w-[200px] w-[400px] h-auto my-4'
                src='/images/acgt-logo-2022.png'
                alt='acgt-logo'
              />
            </NavLink>
          )}

          <div className='hidden sm:block border-2 border-[var(--color-primary-purple)] h-[65%]  mx-10'></div>
          
          <p className='hidden sm:block text-lg xl:text-xl font-bold text-[var(--color-primary-purple)] py-4 min-w-[300px]'>
            A superior sequencing service,
            <br /> base by base.
          </p>
     
          <div
            id='menu-toggle'
            className='absolute right-[25px] lg:hidden'
            onClick={() => setMenuToggle(!menuToggle)}
          >
            {menuToggle ? (
              <IoClose size={45} color='var(--color-primary-purple)' />
            ) : (
              <IoMenu size={45} color='var(--color-primary-purple)' />
            )}
          </div>
        </div>
        <div className=' hidden lg:flex scale-[85%] origin-right xl:scale-[100%] w-full flex-col justify-center items-end'>
          <div className='min-w-[380px] flex justify-center items-center gap-[22px]'>
            {isLoggedIn ? (
              <>
              <Link 
              className='flex items-center' to='/profile'>
                <img
                  alt='profile icon'
                  src='/images/Profile.svg'
                  className='h-[32px] w-auto mx-2'
                />
                <p className='uppercase font-bold text-[var(--color-primary-purple)] py-4'>
                  Profile
                </p>
              </Link>
              <div className='border-1 border-[#eee] w-[1px] h-[40%]'></div>
              <Link to='/dashboard'>
                <p className='uppercase font-bold text-[var(--color-primary-purple)] py-4'>
                  Dashboard
                </p>
              </Link>
              <div className='border-1 border-[#eee] w-[1px] h-[40%]'></div>
              <Link  onClick={handleUserLogout}>
                  <p className='uppercase font-bold text-[var(--color-primary-purple)] py-4'>
                    Log Out
                  </p>
                </Link>
              </>
            ) : (
              <>
                <Link to='/'>
                  <p className='uppercase font-bold text-[var(--color-primary-purple)] py-4'>
                    Log In
                  </p>
                </Link>
              </>
            )}

          </div>
          {isLoggedIn && isTokenValid() ?
          <Link to='/quoterequest'
          onClick={() => {
            dispatch(resetQuoteRequestState())
            dispatch(resetQuoteRequestPage(0));
            }}>
            <button className='px-4 py-2 rounded-3xl font-bold text-[var(--color-primary-purple)] w-[380px] bg-[var(--color-secondary-tangerine)] uppercase mt-2'>
              Request a Quote
            </button>
          </Link>
          :
          <Link to='/quoterequest'>
            <button className='px-4 py-2 rounded-3xl font-bold text-[var(--color-primary-purple)] w-[380px] bg-[var(--color-secondary-tangerine)] uppercase mt-2'>
              Request a Quote
            </button>
          </Link>
          }
        </div>
      </header>

      {menuToggle && (
        <>
          <nav className='z-10 pb-10 lg:hidden justify-between items-center bg-[var(--color-primary-purple)] mb-4'>
          <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
              <NavLink
                to='https://acgtinc.com/'
                target="_blank"
                className='text-[18px] uppercase text-white  font-bold cursor-pointer'
              >
                HOME
              </NavLink>
            </div>
          <div
              className='hidden md:flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'
              ref={ordersDropdownRef}
              onClick={toggleOrdersDropdown}
            >
              <NavLink
                className='pl-4 text-[18px] uppercase text-white font-bold cursor-pointer'
              >
                Order Forms
              </NavLink>
              <IoIosArrowDown
                className='text-2xl text-white m-2 cursor-pointer' 
              />
            </div>
            {isOrdersOpen && (
              <div className='text-xl'>
                <div className='bg-[var(--color-primary-purple)]'>
                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/sppe'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    Single Pass Primer Extension
                  </NavLink>  
				{!excludeCorp && 
					<NavLink
                    onClick={closeDropdowns}
                    to='/orders/wps'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
					>
						Whole Plasmid Sequencing
					</NavLink>
                }

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/dcss'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    Direct Colony Sequencing
                  </NavLink>
				
				<NavLink
					onClick={closeDropdowns}
					to='/orders/fla'
					className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
				>
					Fragment Length Analysis
				</NavLink>
				
                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/htp'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    High Throughput Sequencing
                  </NavLink>

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/primer'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    Primer Synthesis & Design Only
                  </NavLink>

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/fsa'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    Full Sequence Analysis
                  </NavLink>

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/genomic'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    gDNA Target Sequencing
                  </NavLink>

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/ngs'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    NGS Services Bundle
                  </NavLink>

                  <NavLink
                    onClick={closeDropdowns}
                    to='/orders/contract'
                    className='block px-6 py-2 text-center text-white hover:bg-[var(--color-hover-purple)]'
                  >
                    Contract Research Project
                  </NavLink>
                </div>
              </div>
            )}
            <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
              <NavLink
                to='/orderhistory'
                className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                onClick={closeMenu}
              >
                My Orders
              </NavLink>
            </div>
            <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
              <NavLink
                to='/pricing'
                className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                onClick={closeMenu}
              >
                Pricing
              </NavLink>
            </div>
            <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
              <NavLink
                to='/primerbank'
                className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                onClick={closeMenu}
              >
                Primer Bank
              </NavLink>
            </div>
            <div
              className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'
              ref={acgtCardDropdownRef}
            >
              <NavLink
                to='/acgtcard'
                className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                onClick={() => {
                  closeMenu()
                  dispatch(resetAcgtCard())
                  dispatch(setCardPage(0))
                } 
              }
              >
                ACGT Card
              </NavLink>
            </div>

            <hr className='bg-white h-[3px] mx-4 my-2' />

            {isLoggedIn ? (
              <>
                <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    to='/profile'
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer flex items-center'
                    onClick={closeMenu}
                  >
                    <img
                      alt='profile icon'
                      src='/images/Profile_light.png'
                      className='h-[32px] w-auto mx-2'
                    />
                    Profile
                  </NavLink>
                </div>

                <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    to='/dashboard'
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                    onClick={closeMenu}
                  >
                    Dashboard
                  </NavLink>
                </div>

                <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                    onClick={() => {
                      closeMenu()
                      handleUserLogout()
                    }}
                  >
                    log out
                  </NavLink>
                </div>
              </>
            ) : (
              <>
              {/* <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    to='/profile'
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer flex items-center'
                    onClick={closeMenu}
                  >
                    <img
                      alt='profile icon'
                      src='/images/Profile_light.png'
                      className='h-[32px] w-auto mx-2'
                    />
                    Profile
                  </NavLink>
                </div>

                <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    to='/dashboard'
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                    onClick={closeMenu}
                  >
                    Dashboard
                  </NavLink>
                </div> */}
                <div className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'>
                  <NavLink
                    to='/'
                    className='text-[18px] uppercase text-white  font-bold cursor-pointer'
                    onClick={closeMenu}
                  >
                    log in
                  </NavLink>
                </div>
              </>
            )}

            <div className='flex flex-col items-center'>
              <Link to='/quoterequest' onClick={closeMenu}>
                <button className='px-4 py-2 rounded-3xl font-bold text-[var(--color-primary-purple)] w-[300px] bg-[var(--color-secondary-tangerine)] uppercase mt-4'>
                  Request a Quote
                </button>
              </Link>
            </div>
          </nav>
        </>
      )}

      {nucoreUser ? 
      <nav className="hidden sm:flex justify-between h-16 items-center bg-[var(--color-primary-purple)]">
        {isLoggedIn && <>
          <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)] '>
          <NavLink
            to='https://acgtinc.com/'
            target="_blank"
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            HOME
          </NavLink>
        </div>
          <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink
            to='/orderhistory'
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            My Orders
          </NavLink>
        </div>
        <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink
            to='/primerbank'
            className='xl:text-xl  uppercase text-white  font-bold cursor-pointer'
          >
            Primer Bank
          </NavLink>
        </div>
        </>}
      </nav> 
      :  
      <nav 
      style={{pointerEvents: isLoggedIn ? 'auto': 'none'}}
      className='hidden lg:flex justify-between items-center h-16 bg-[var(--color-primary-purple)]'>
       {isLoggedIn && 
       <>
       <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink
            to='https://acgtinc.com/'
            target="_blank"
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            HOME
          </NavLink>
        </div>
        <div
          className='relative group flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'
          ref={ordersDropdownRef}
          onMouseLeave={() => setIsOrdersOpen(false)}
        >
          <NavLink
            to='/dashboard'
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            Order Forms
          </NavLink>
          <IoIosArrowDown
          onMouseOver={() => setIsOrdersOpen(true)}
          className='text-xl xl:text-2xl text-white m-2 cursor-pointer'
          />
          {isOrdersOpen && (
            <div className='z-10 origin-top-right absolute left-1/2 -translate-x-1/2 top-16 w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5'>
              <div className='bg-[var(--color-primary-purple)] text-sm xl:text-[17px]'>
                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/sppe'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  Single Pass Primer Extension
                </NavLink>
			
				{!excludeCorp && 
				<NavLink
					onClick={closeDropdowns}
					to='/orders/wps'
					className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
					Whole Plasmid Sequencing
                </NavLink>
                }

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/dcss'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  Direct Colony Sequencing
                </NavLink>
				
				<NavLink
					onClick={closeDropdowns}
					to='/orders/fla'
					className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
				>
					Fragment Length Analysis
				</NavLink>
				
                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/htp'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  High Throughput Sequencing
                </NavLink>

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/primer'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  Primer Synthesis & Design Only
                </NavLink>

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/fsa'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  Full Sequence Analysis
                </NavLink>

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/genomic'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  gDNA Target Sequencing
                </NavLink>

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/ngs'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  NGS Services Bundle
                </NavLink>

                <NavLink
                  onClick={closeDropdowns}
                  to='/orders/contract'
                  className='block px-6 py-4 text-white hover:bg-[var(--color-hover-purple)]'
                >
                  Contract Research Project
                </NavLink>
              </div>
            </div>
          )}
        </div>
        <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink
            to='/orderhistory'
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            My Orders
          </NavLink>
        </div>
        <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink to='/pricing' className='xl:text-xl uppercase text-white  font-bold cursor-pointer'>
            Pricing
          </NavLink>
        </div>
        <div className='flex flex-1 justify-center items-center py-2 h-16 hover:bg-[var(--color-hover-purple)]'>
          <NavLink
            to='/primerbank'
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
          >
            Primer Bank
          </NavLink>
        </div>
        <div
          className='relative group flex flex-1 justify-center items-center p-2 h-16 hover:bg-[var(--color-hover-purple)]'
          ref={acgtCardDropdownRef}
        >
          <NavLink
            to='/acgtcard'
            className='xl:text-xl uppercase text-white  font-bold cursor-pointer'
            onClick={() => {
              dispatch(resetAcgtCard())
              dispatch(setCardPage(0))}
            } 
          >
            ACGT Card
          </NavLink>
        </div>
       </>
       }
       
      </nav>
      }
    </>
  );
};

export default Header;